import type React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "~/components/ui/button";
import NotFoundSVG from "~/images/notFound.svg?react";
import type { RootState } from "~/store";
import styles from "./index.module.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.auth);

  const handleHomeClick = () => {
    navigate(`/${currentUser?.organization_id}/home`);
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["content"]}>
        <div className={styles["svgContainer"]}>
          <NotFoundSVG />
        </div>
        <h1 className={styles["title"]}>404</h1>
        <p className={styles["message"]}>お探しのページは見つかりませんでした。</p>
        <p className={styles["submessage"]}>URLをご確認のうえ、再度お試しください。</p>
        <div className={styles["buttonContainer"]}>
          <Button label="ホーム" onClick={handleHomeClick} styleType="blue" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
